import { Injectable } from '@angular/core';
import { Brand } from 'src/brands/brand';

@Injectable({
  providedIn: 'root'
})
export class ParentMessengerService {

  constructor() { }

  public navigate(link: string | undefined) {
    let message = {
      type: "sipts-loadlink",
      link: link ?? ""
    };

    window.parent.postMessage(message, Brand.targetOrigin);
  }
}
